import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FormattedMessage } from 'sb-react-intl'
import { sentry, getTruncatedText } from 'common/helpers'

import toggleOpen  from 'decorators/toggleOpen'

import messages from './messages'
import s from './ToggleTruncate.scss'


const ToggleTruncate = (props) => {
  const { children = '', className, length, isToggleActive, toggleOpen, toggleClose } = props

  if (typeof children !== 'string') {
    sentry.captureException('Not a string passed as a children to ToggleTruncate', {
      extra: {
        children,
        className,
        length,
      },
    })

    return children
  }

  // 1.3 here means additional 30% to length
  // so if children text length is 258 and length prop is 200 we don't truncate text
  const isTruncateNecessary = length > 1 && children.length > length * 1.3

  if (!isTruncateNecessary) {
    return <div className={className} dangerouslySetInnerHTML={{ __html: children }} />
  }

  const rootClassName = cx(className, s.container)

  const text        = isToggleActive ? children : getTruncatedText(children, length)
  const action      = isToggleActive ? toggleClose : toggleOpen
  const actionTitle = isToggleActive ? messages.hide : messages.readMore

  return (
    <div className={rootClassName}>
      <div className={s.text} dangerouslySetInnerHTML={{ __html: text }} />
      <FormattedMessage
        className={s.action}
        tag="button"
        onClick={action}
        {...actionTitle}
      />
    </div>
  )
}

ToggleTruncate.propTypes = {
  children: PropTypes.string.isRequired,
  length: PropTypes.number,
}

ToggleTruncate.defaultProps = {
  length: 0,
}


export default toggleOpen()(ToggleTruncate)
